import React from 'react';
import Header from './components/Header/Header';
import Gallery from './components/Gallery/Gallery';
import Footer from './components/Footer/Footer';
import './App.css';

const App = () => {
  const sourcePlanUrl = process.env.REACT_APP_PLAN_URL;
  const assetBaseUrl = process.env.REACT_APP_ASSET_BASE_URL;

  const finalPlanUrl = (() => {
    if (!sourcePlanUrl) return '';
    const targetUrl = new URL(sourcePlanUrl);
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key) => {
      targetUrl.searchParams.set(key, value);
    });
    return targetUrl.toString();
  })();

  const handleClick = (e) => {
    // 如果點擊的不是特定的頁腳連結
    if (!e.target.closest('.djdlCe a')) {
      window.location.href = finalPlanUrl;
    }
  };

  return (
    <div className="ftJZqC" onClick={handleClick}>
      <div className="ftJZqC">
        <Header finalPlanUrl={finalPlanUrl} assetBaseUrl={assetBaseUrl} />
        <Gallery finalPlanUrl={finalPlanUrl} assetBaseUrl={assetBaseUrl} />
        <Footer assetBaseUrl={assetBaseUrl} />
      </div>
    </div>
  );
};

export default App; 